
// import React, { useEffect, useState } from "react";
// import "./VivaExam.css";

// export const QuestionTabs = ({ currentQuestion, setCurrentQuestion, questionStatus,questions }) => {



//   const getTabClass = (qId) => {
//     let base = "question-tab";
//     if (qId === questions[currentQuestion]?.Id) base += " active-tab";
//     if (questionStatus[qId] === "answered") base += " completed-tab";
//     return base;
//   };


//   return (
//     <div
//       className="mt-2"
//       id="question-tabs"
//       style={{ justifyContent: "space-between", padding: "0 16px", marginBottom: "16px" }}
//     >
//       {questions.map((qObj, idx) => {
//         const isMandatory = qObj.IsMandatory === 1 || qObj.IsMandatory === "1";

//         return (
//           <button
//             key={qObj.Id}
//             className={getTabClass(qObj.Id)}
//             onClick={() => setCurrentQuestion(idx)}
//             title={isMandatory ? "Mandatory Question" : `Question ${idx + 1}`}
//             style={{ position: "relative" }}
//           >
//             Q{idx + 1}

//             {/* Red Star for Mandatory */}
//             {isMandatory && (
//               <span
//                 style={{
//                   color: "red",
//                   fontWeight: "bold",
//                   marginLeft: "5px",
//                   fontSize: "14px",
//                 }}
//               >
//                 ★
//               </span>
//             )}
//           </button>
//         );
//       })}
//     </div>
//   );
// };





import React from "react";
import "./VivaExam.css";
export const QuestionTabs = ({
  currentQuestion,
  setCurrentQuestion,
  questionStatus,
  questions,
}) => {

  const getTabClass = (qId) => {
    let base = "question-tab";

    if (qId === questions[currentQuestion]?.Id)
      base += " active-tab";

    if (questionStatus[qId] === "answered")
      base += " completed-tab";

    return base;
  };

  return (
    <div
      className="mt-2"
      id="question-tabs"
      style={{
        justifyContent: "space-between",
        padding: "0 16px",
        marginBottom: "16px",
      }}
    >
      {questions.map((qObj, idx) => {

        const qId = qObj.Id;

        const isMandatory =
          qObj.IsMandatory === 1 ||
          qObj.IsMandatory === "1" ||
          qObj.IsMandatory === true;

        return (
          <button
            key={qId}
            className={getTabClass(qId)}
            onClick={() => setCurrentQuestion(idx)}
            title={isMandatory ? "Mandatory Question" : `Question ${idx + 1}`}
            style={{ position: "relative" }}
          >
            Q{idx + 1}

            {isMandatory && (
              <span
                style={{
                  color: "red",
                  fontWeight: "bold",
                  marginLeft: "5px",
                  fontSize: "14px",
                }}
              >
                ★
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};